window.global ||= window
import Vue from 'vue'
import _ from 'lodash'
window._ = _
import { i18n, loadLanguage } from '@/plugins/i18n'
const VITE_APP_ENV = import.meta.env.VITE_APP_ENV
Vue.prototype.$isProduction = VITE_APP_ENV === 'production'

async function fetchConfigAndInitApp() {
    try {
        // 2FA middleware renderuje widok auth.google2fa pod chronionym URL (np. /koszty/...);
        // Vue Router (mode: history) nie zmatchuje takiego URL i nie wyrenderuje Google2FA.
        // Blade podaje targetVuePath, a my zamieniamy URL zanim router zostanie zainicjalizowany.
        if (window.authConfig?.targetVuePath && window.location.pathname !== window.authConfig.targetVuePath) {
            window.history.replaceState({}, '', window.authConfig.targetVuePath)
        }

        // Dla auth nie potrzebujemy config z backendu, używamy prostszej konfiguracji
        window.AppFrontConfig = {
            panel_type: 'auth',
            locale: document.documentElement.lang || 'pl'
        }

        await import('@core/utils/functions')

        const [
            { default: App },
            { default: router },
            { default: store },
            { default: EventEmit },
            { default: http },
            { BootstrapVue },
            { ValidationProvider, ValidationObserver },
            { default: VueMoment },
            { default: PortalVue },
            { default: FieldVSelect },
            { default: CoreFilters },
            { default: GlobalToast }
        ] = await Promise.all([
            import('./App'),
            import('./router'),
            import('./store'),
            import('@/plugins/event-emit'),
            import('@/plugins/http.js'),
            import('bootstrap-vue'),
            import('vee-validate'),
            import('vue-moment'),
            import('portal-vue'),
            import('@admin/components/form/fields/FieldVSelect'),
            import('@core/plugins/filters'),
            import('@core/components/GlobalToast'),
            import('@/plugins/validation'),
            import('@core/plugins/bootstrap'),
            import('@core/plugins/vue-toastification')
        ])

        Vue.prototype.$panel = 'auth'

        Vue.use(EventEmit)
        Vue.use(http)
        Vue.use(BootstrapVue)
        Vue.component('ValidationProvider', ValidationProvider)
        Vue.component('ValidationObserver', ValidationObserver)
        Vue.mixin({ methods: { route } })
        Vue.use(VueMoment)
        Vue.use(PortalVue)
        Vue.component('VSelect', FieldVSelect)
        Vue.use(CoreFilters, { store })
        Vue.component('GlobalToast', GlobalToast)

        Vue.config.productionTip = false

        new Vue({
            router,
            store,
            i18n,
            async created() {
                await loadLanguage()
            },
            render: (h) => h(App)
        }).$mount('#app')
    } catch (error) {
        console.error('Wystąpił błąd podczas inicjalizacji aplikacji auth:', error)
    }
}

fetchConfigAndInitApp().then(() => document.dispatchEvent(new Event('appInitialized')))
